import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import {
	Box,
	Button,
	DialogActions,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	styled,
	tableCellClasses,
} from '@mui/material';
import { money } from '../../../helpers/utils';
import { Text } from '../../orders/NewBiasForm4';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ref} {...props} />;
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: '#01579b',
		color: theme.palette.common.white,
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 14,
	},
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	'&:nth-of-type(odd)': {
		backgroundColor: theme.palette.action.hover,
	},
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0,
	},
}));

export const BiasVariablesDialog = ({ open, handleClose, variables = [] }) => {
	return (
		<Dialog
			maxWidth='sm'
			open={open}
			onClose={handleClose}
			TransitionComponent={Transition}
		>
			{/* Content */}
			<Box sx={{ flexGrow: 1 }}>
				<div style={{ padding: '20px' }}>
					<Text variant='h6' text='Variables' />

					<TableContainer component={Paper}>
						<Table sx={{ width: '100%' }} aria-label='simple table'>
							<TableHead>
								<StyledTableRow>
									<StyledTableCell align='center'>
										#
									</StyledTableCell>
									<StyledTableCell align='left'>
										Variable
									</StyledTableCell>
									<StyledTableCell align='center'>
										Precio por variable
									</StyledTableCell>
									<StyledTableCell align='center'>
										Importe unitario acumulado
									</StyledTableCell>
								</StyledTableRow>
							</TableHead>
							<TableBody>
								{variables.map((variable, indexTable) => (
									<StyledTableRow
										key={variable.name}
										sx={{
											'&:last-child td, &:last-child th':
												{ border: 0 },
										}}
									>
										<StyledTableCell align='center'>
											{indexTable + 1}
										</StyledTableCell>
										<StyledTableCell align='left'>
											{variable.name}
										</StyledTableCell>
										<StyledTableCell align='center'>
											{money(variable.price)}
										</StyledTableCell>
										<StyledTableCell align='center'>
											{money(variable.unitImport)}
										</StyledTableCell>
									</StyledTableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				</div>
			</Box>
			<DialogActions>
				<Button onClick={() => handleClose()}>Ok</Button>
			</DialogActions>
		</Dialog>
	);
};
